import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { io } from "socket.io-client";

import { Link } from "react-router-dom";

import { 
    BackButton, 
    ButtonContainer, 
    CardContainer, 
    CardCustom, 
    CardLogo, 
    CardHeader, 
    Title, 
    SubTitleProtocol,
    AttendantContainer,
    AttendantName,
    Attendant,
    MessageBlock,
    MessageContainer,
    Message,
    MessageText,
    MessageFooter,
    FormContainer,
    Textarea,
    SendButtonContainer,
    SendButton
} from "./styles";

//Actions Functions
import { newMessage } from "../../redux/actions/messages";

//Interfaces
import { PayloadMessageInterface } from "../../redux/interfaces/messagesInterface"

//Assets
import Logo from "../../assets/img/logo.svg";
import backArrowOrange from "../../assets/icons/back-arrow-orange.svg";
import backArrowWhite from "../../assets/icons/back-arrow-white.svg";
import attendantPhoto from "../../assets/img/jefer.png";
import sendGray from "../../assets/icons/send-gray.svg";
import sendWhite from "../../assets/icons/send-white.svg";
    
const Chat = () => {
    const [ isBackButtonHover, setIsBackButtonHover ] = useState(false);
    const [ isSendButtonHover, setIsSendButtonHover ] = useState(false);
    const [ isNewConversation, setIsNewConversation] = useState(true);
    
    const messages = useSelector((state: {messages: any}) => state.messages);
    const dispatch = useDispatch();
    const login = useSelector((state: {login: any}) => state.login);
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
        
    const query = useQuery();
    const socket = useMemo(
        () => 
            io("https://api.100pay.org", {
                transports: ["websocket", "polling", "flashsocket"], 
                autoConnect: false, 
                query: {
                    branchId: login.user.branchs.id,
                }
            }), 
        [login.user.branchs.id]
    )
    
    useEffect(() => {
        socket.connect();

        const handleNewMessage = (data: {message: string}) => {
            dispatch(newMessage({
                chatId: query.get("id") || "",
                from: "attendant",
                text: data.message
            }));
        }

        socket.on("connect", () => {
            socket.on("receivedMessage", handleNewMessage);
        });
    }, [messages]);

    const messagesGenerator = () => {
        return messages.messageAcc.map((message: PayloadMessageInterface, index: number) => {
            return(
                <MessageBlock key={index} isUserMessage={message.from === "user"}>
                    <Message isUserMessage={message.from === "user"}>
                        <MessageText>{message.text}</MessageText>
                        {/* <MessageFooter>{message.date}</MessageFooter>                */}
                    </Message>
                </MessageBlock>
            )
        })
    }

    return (
        <div className="container">
            <ButtonContainer>
                <Link to="/admin/dashboard">
                    <BackButton
                        onMouseEnter={() => setIsBackButtonHover(true)}
                        onMouseLeave={() => setIsBackButtonHover(false)}
                    >
                        <img src={isBackButtonHover ? backArrowWhite : backArrowOrange} style={{marginRight: 16}}/> 
                        Ir para Dashboard
                    </BackButton>
                </Link>
            </ButtonContainer>
            <CardContainer>
                <CardCustom>
                    <CardLogo>
                        <img src={Logo} style={{ height: 21 }}/>
                    </CardLogo>
                    <CardHeader>
                        <div>
                            <Title>Chat</Title>
                            <SubTitleProtocol>Protocolo: 254225</SubTitleProtocol>
                        </div>

                        {/* <AttendantContainer>
                            <div style={{marginRight: 8}}>
                                <AttendantName>Jeferson</AttendantName>
                                <Attendant>Atendente</Attendant>
                            </div>
                            <img src={attendantPhoto}/>
                        </AttendantContainer> */}
                    </CardHeader>
                    
                    
                    <MessageContainer>
                        { messagesGenerator() }
                    </MessageContainer>

                    <Formik
                        initialValues={{
                            message: ""
                        }}

                        onSubmit={async (values, {resetForm}) => {
                            socket.emit("sendMessage", {
                                chatId: query.get("id"),
                                message: values.message,
                                userId: login.user.id,
                                ownerId: login.user.branchs.sellerOwner100PayId,
                                newMessage: isNewConversation
                            });

                            dispatch(newMessage({
                                chatId: query.get("id") || "",
                                from: "user",
                                text: values.message
                            }));

                            setIsNewConversation(false);
                            resetForm();
                        }}
                    >
                        <Form>
                            <FormContainer>
                                <Field id="message" name="message" placeholder="Escreva sua mensagem aqui...." as={Textarea}/>
                                <SendButtonContainer>
                                    <SendButton
                                        onMouseEnter={() => setIsSendButtonHover(true)}
                                        onMouseLeave={() => setIsSendButtonHover(false)}
                                    >
                                        <img src={isSendButtonHover ? sendWhite : sendGray} style={{marginRight: 14}}/>
                                        Enviar
                                    </SendButton>
                                </SendButtonContainer>
                            </FormContainer>
                        </Form>
                    </Formik>
                </CardCustom>
            </CardContainer>
        </div>
    );
};

export default Chat;